export const TOP_BAR_MOBILE_H_PADDING = 12
export const TOP_BAR_DESKTOP_H_PADDING = 20
